import * as Constants from '../constants/';

export default function(state = {}, action) {
  switch (action.type) {
    case Constants.UPDATE_WELCOME_MAT:
      return {
        ...state,
        [action.name]: {
          shouldOpen: action.shouldOpen
        }
      };
    default:
      return state;
  }
}
